import React from 'react'
import { Outlet } from 'react-router-dom'
import OrganizationTabs from './OrganizationTabs'

function OrganizationLayout() {
  return (
    <div className='org_layout'>
      <OrganizationTabs />
      <Outlet />
    </div>
  )
}

export default OrganizationLayout